import React from 'react';
import Utils from '../utils/utils';
import { VstLoader } from 'vstui'
import moment from 'moment';

const Ancillaries = ({ user, resources }) => {

	const filterDate = date => {
    const time = moment(date).calendar();
		return i18n.t('resources.expires') + " " + time;
	};

	var ancillaries;
	if (!user || user.licenseUpdating || !resources) {
		ancillaries = <VstLoader delay={500}>{i18n.t('resources.loading')}</VstLoader>;
	} else if (resources.length > 0) {
  	ancillaries = resources.map( (item, index) => {
      let detailsUrl = "#/resources/ancillaries/" + item.isbn;
			if (item.ancillariesCount > 0){
	  		return (
	    		<div className="clear card" key={index}>
			      <div className="left">
			        <img className="cover" src={item.coverURL} alt="" />
			        <div className="details">
			          <strong className="title">{Utils.toHTML(item.title)}</strong>
			          <span className="author">{item.author}</span>
			          <span className="expiration">{filterDate(item.expires)}</span>
			        </div>
			      </div>
			      <div className="right">
			        <div className="link-container">
			          <a href={detailsUrl}>{item.ancillariesCount} {i18n.t('resources.ancillaries')}
									<img src={require('../../img/arrow_blue_right.svg')} alt="" />
								</a>
			        </div>
			      </div>
			    </div>
			  );
			}
    });
  } else {
		ancillaries = <p>{i18n.t('resources.no-resources')}</p>;
	}

  return (
  	<div>
	 		{ancillaries}
	 	</div>
  );
};

export default Ancillaries;


/** WEBPACK FOOTER **
 ** ./src/js/components/ancillaries.jsx
 **/